export default __webpack_public_path__ + "static/media/tapeOne.c8ea55e9.svg";